import {useContext} from "react";
import {SessionContext} from "joynt/meeting/agora-ng/context/SessionContext";

export function useSessionContext() {
    return useContext(SessionContext);
}